<template>
  <div class="home">
    <vs-row>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" lg="6" sm="12">
        <img src="../assets/Logo.svg" alt="Logo" class="homeLogo" width="90%">
        <h3 class="slogan">
          {{ $t("app.home.description.first") }}
          <span class="sloganAccent">{{
            $t("app.home.description.second")
          }}</span>
          {{ $t("app.home.description.last") }}
        </h3>
        <vs-button size="large" class="callToAction" @click="() => goTo('contact')">
          {{ $t("app.home.callToAction.button") }}
        </vs-button>
        <div class="homeServices">
          <div class="homeIcon">
            <vs-avatar size="69">
              <i class='bx bxs-package' />
            </vs-avatar>
          </div>
          <h4 class="homeServicesText">
            {{ $t("app.home.services.design") }} /
            {{ $t("app.home.services.branding") }} /
            {{ $t("app.home.services.advertisement") }} /
            {{ $t("app.home.services.webDesign") }}
          </h4>
        </div>
      </vs-col>

      <vs-col vs-type="flex" vs-justify="center" vs-align="center" lg="6" sm="12">
        <div class="homeProjects">
          <div class="row">
            <div
              v-for="(item, index) in projectsPreview"
              :key="index" vs-type="flex"
              class="col-sm-12 col-lg-6 homeProjectsGrid"
            >
              <div class="homeProjectContainer">
                <vs-card>
                  <template #title>
                    <h3>{{ item.name }}</h3>
                  </template>
                  <template #img>
                    <img :src="require(`../assets/projects/${item.image}`)" :alt="item.name">
                  </template>
                  <template #text>
                    <p>
                      {{ $t(item.work) }}
                    </p>
                  </template>
                </vs-card>
              </div>
            </div>
            <div
                lg="6"
                sm="12"
                class="col-sm-12 col-lg-6 homeProjectsGrid"
                style="heigth: 80%;"
              >
              <div class="homeServicesCallToAction">
                <vs-button border size="large" block @click="() => goTo('portfolio')">
                  {{ $t("app.home.explore.button") }}
                  <i class='bx bx-chevron-right' />
                </vs-button>
              </div>
            </div>
          </div>
        </div>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
// @ is an alias to /src
import { getProjects } from '../server/serverHelper';

export default {
  name: 'Home',
  props: {
    setActive: Function,
  },
  data: () => ({
    projectsPreview: [],
  }),
  beforeMount() {
    const previewProjects = getProjects(3);
    this.projectsPreview = previewProjects.data;
  },
  methods: {
    goTo(to) {
      this.setActive(to);
      this.$router.push({ path: `/${to}` });
    },
  },
};
</script>

<style scoped>
.home {
  height: 100%;
}

.homeLogo {
  margin-top: 3rem;
}

.slogan {
  font-weight: 400;
  font-size: 2rem;
}

.sloganAccent {
  color: #ffba00;
}

.callToAction {
  padding-left: 2rem;
  padding-right: 2rem;
}

.homeServices {
  display: flex;
  align-items: center;
  margin-top: 6rem;
}

.homeIcon {
  margin-right: 1rem;
}

.vs-avatar i {
  font-size: 2.5rem;
}

.homeServicesText {
  font-weight: 400;
  font-size: 1.4rem;
}

.homeProjects {
  margin-left: 1rem;
}

.homeServicesCallToAction {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}

.homeServicesButton {
  display: flex;
}

.homeProjectsGrid {
  padding: 0.5rem;
}

.homeProjectContainer {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
}
</style>
